import { Button } from "@mui/material";

export function OnBoarding() {
  return (
    <Button
      sx={onBoardingButtonStyles}
      onClick={() => document.dispatchEvent(new Event("@my-intro-modal:open"))}
    >
      <i className="ri-question-line" />
      Intro to myTW
    </Button>
  );
}

const onBoardingButtonStyles = {
  display: "flex",
  gap: "4px",
  color: "#616161",
  padding: 0,
  margin: "20px 40px 32px 40px",
  fontSize: "12px",
  "&:hover": {
    backgroundColor: "#fff",
  },
};
